.container {
  :global {
    .ant-radio-group {
      label {
        &:hover {
          background-color: var(--bc-color-fill-secondary);
        }

        &.ant-radio-button-wrapper:not(:first-child)::before {
          display: none;
        }

        &.ant-radio-button-wrapper {
          box-shadow: none;
        }
      }
    }
  }

  &.tabsPrimary {
    :global {
      .ant-radio-group {
        display: inline-flex;
        border: 1px solid var(--bc-color-border);
        background: var(--bc-color-bg-container);
        border-radius: 8px;

        label {
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
          color: var(--bc-color-text-secondary);
          border: none;
          border-radius: 8px;

          &.ant-radio-button-wrapper {
            background: transparent;
            &:hover {
              background-color: var(--bc-color-fill-secondary);
            }
          }

          &.ant-radio-button-wrapper-checked {
            border-color: var(--bc-color-border);
            color: var(--bc-color-text);
            background-color: var(--bc-color-primary-bg);

            &:hover {
              background-color: var(--bc-color-primary-bg-hover);
            }
          }

          span {
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 1px;
            line-height: 12px;
            text-align: center;
          }
        }
      }
    }
  }

  &.tabsSecondary {
    :global {
      .ant-radio-group {
        display: inline-flex;
        border-color: var(--bc-color-border);
        background: var(--bc-color-fill-secondary);
        border-radius: 8px;

        label {
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
          color: var(--bc-color-text-secondary);
          border: none;

          &:first-child {
            border-bottom-left-radius: 8px;
            border-top-left-radius: 8px;
          }

          &:last-child {
            border-bottom-right-radius: 8px;
            border-top-right-radius: 8px;
          }

          &.ant-radio-button-wrapper {
            background: transparent;
            border-radius: 8px;
            &:hover {
              background-color: var(--bc-color-border-secondary);
            }
          }

          &.ant-radio-button-wrapper-checked {
            border: 1px solid var(--bc-color-border-secondary);
            border-radius: 8px;
            border-bottom: 2px solid var(--bc-color-primary);
            color: var(--bc-color-text);
            background-color: var(--bc-color-bg-container);

            &:hover {
              background-color: var(--bc-color-border-secondary);
            }
          }

          span {
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 1px;
            line-height: 12px;
            text-align: center;
          }
        }
      }
    }
  }

  &.buttons {
    :global {
      .ant-radio-group {
        label {
          color: var(--bc-color-text);
          border: 1px solid var(--bc-color-border);
          border-radius: 4px;
          margin-bottom: 8px;
          padding-left: 8px;
          padding-right: 8px;

          &.ant-radio-button-wrapper-checked {
            color: var(--bc-color-text-light-solid);
            background-color: var(--bc-color-primary);
            svg {
              path:last-child {
                fill: var(--bc-color-text-light-solid);
              }
            }

            &:hover {
              color: var(--bc-color-text-light-solid);
            }
          }

          &:not(:last-child) {
            margin-right: 8px;
          }

          &:hover {
            color: var(--bc-color-text);
          }
        }
      }
    }
  }
}
